// React Imports
import * as React from "react";
import {useDispatch, useSelector} from "react-redux";


// Mui Imports
import MenuItem from "@mui/material/MenuItem";
import {
    ListItemIcon,
    ListItemText,
    Tooltip
} from "@mui/material";


// App Imports

import Box from "@mui/material/Box";
import ThumbUpIcon from "@mui/icons-material/ThumbUp";
import {contractUpdate} from "../../../Contract/ContractClient";
import {changeWorkQueue} from "../../workQueueSlice";
import BookmarkIcon from "@mui/icons-material/Bookmark";


// main function
export default function TagContract({ onMenuClose, rowContractData, selectorContractList }) {

    // ****************** BEGIN DISPATCH ****************************

    const dispatchData = useDispatch();

    // ****************** END DISPATCH ****************************

    const currentUserName = localStorage.getItem('userName');
    const contractArray = useSelector((state) => state.workQueueSlc.value.mousedContractContractIdArray);

    const handleTag = () => {
        onMenuClose();
        contractUpdate(contractArray, [], [],'Update Status',
            '2034', null, currentUserName, true)
            .then(() => {
                dispatchData(changeWorkQueue({workQueueCGridRefresh: true}));
            });
    };

    // const handleTag = () => {
    //     onMenuClose();
    //     updateStatusByContractList(selectorContractList, 'Tagged')
    //         .then(() => {
    //             dispatchData(changeWorkQueue({workQueueCGridRefresh: true}));
    //         });
    // };


    return (

        <Box>
            {(rowContractData.contractLevel === "Series" ||
                    rowContractData.contractLevel === "Season" ||
                    rowContractData.contractLevel === "Residuals" ||
                    rowContractData.contractLevel === "Property" ||
                    rowContractData.contractLevel === "Labor Group" ||
                    (rowContractData.contractLevel === "Guild" && rowContractData.contractStatus !== "Tagged")) &&
                <MenuItem onClick={handleTag}>
                    <ListItemIcon>
                        <BookmarkIcon fontSize="small" />
                    </ListItemIcon>
                    <ListItemText>Tag</ListItemText>
                </MenuItem>}
        </Box>

    )

}
